import { onMounted, onUnmounted } from 'vue';

export function useRecaptchaBadge() {
	onMounted(() => {
		document.body.classList.add('recaptcha-badge-visible');
	});

	onUnmounted(() => {
		document.body.classList.remove('recaptcha-badge-visible');
	});
}
